// extracted by mini-css-extract-plugin
module.exports = {"title":"settings_title__3t6tn","logoContainer":"settings_logoContainer__2UYNo","logoPreview":"settings_logoPreview__3Yqfq","logoImage":"settings_logoImage__2L-Ve"};